 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_ACKNOWLEDGMENTS from '@/components/html/05_Acknowledgments'
 import HTML06_PROLOGUE from '@/components/html/06_Prologue'
 import HTML07_1__TOWARD_EMBODIED_VIRTUALITY from '@/components/html/07_1__Toward_Embodied_Virtuality'
 import HTML08_2__VIRTUAL_BODIES_AND_FLICKERING from '@/components/html/08_2__Virtual_Bodies_and_Flickering'
 import HTML09_3__CONTESTING_FOR_THE_BODY_OF_IN from '@/components/html/09_3__Contesting_for_the_Body_of_In'
 import HTML10_4__LIBERAL_SUBJECTIVITY_IMPERILE from '@/components/html/10_4__Liberal_Subjectivity_Imperile'
 import HTML11_5__FROM_HYPHEN_TO_SPLICE__CYBERN from '@/components/html/11_5__From_Hyphen_to_Splice__Cybern'
 import HTML12_6__THE_SECOND_WAVE_OF_CYBERNETIC from '@/components/html/12_6__The_Second_Wave_of_Cybernetic'
 import HTML13_7__TURNING_REALITY_INSIDE_OUT_AN from '@/components/html/13_7__Turning_Reality_Inside_Out_an'
 import HTML14_8__THE_MATERIALITY_OF_INFORMATIC from '@/components/html/14_8__The_Materiality_of_Informatic'
 import HTML15_9__NARRATIVES_OF_ARTIFICIAL_LIFE from '@/components/html/15_9__Narratives_of_Artificial_Life'
 import HTML16_10__THE_SEMIOTICS_OF_VIRTUALITY from '@/components/html/16_10__The_Semiotics_of_Virtuality'
 import HTML17_11__CONCLUSION__WHAT_DOES_IT_MEA from '@/components/html/17_11__Conclusion__What_Does_It_Mea'
 import HTML18_NOTES from '@/components/html/18_Notes'
 import HTML19_INDEX from '@/components/html/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Acknowledgments",
 			"name" : "html/05_Acknowledgments",
 			"component" : HTML05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/html/06_Prologue",
 			"name" : "html/06_Prologue",
 			"component" : HTML06_PROLOGUE
 		},
 		{
 			"path" : "/html/07_1__Toward_Embodied_Virtuality",
 			"name" : "html/07_1__Toward_Embodied_Virtuality",
 			"component" : HTML07_1__TOWARD_EMBODIED_VIRTUALITY
 		},
 		{
 			"path" : "/html/08_2__Virtual_Bodies_and_Flickering",
 			"name" : "html/08_2__Virtual_Bodies_and_Flickering",
 			"component" : HTML08_2__VIRTUAL_BODIES_AND_FLICKERING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js